import React from 'react'
import './SingleProduct.css'
import { AiFillStar } from "react-icons/ai";
import { useState } from 'react';

const SingleProduct = () => {
 
  const data=  JSON.parse(localStorage.getItem("dressdata")) 
  const [imge,setimge]= useState(data.img1)
  const handleimg= (e)=>{
    setimge(e.target.src)
  }
  const handleSubmit=()=>{
    let cartData = JSON.parse(localStorage.getItem("cartData")) || [];
    cartData.push(data);
    localStorage.setItem("cartData",JSON.stringify(cartData));
    alert("Item Saved in Bag ")
    
  }
  return (
    <div id='Singlpro-main'>
    
     <div id="Singlepro-main1">
      {/* firstpic */}

      <div className='Singlepro-main1child1'>
        <div className="Singlepro-main1child1-div">
<img onClick={handleimg} src={data.img1} alt="" />
        </div>
        <div className="Singlepro-main1child1-div">
          <img onClick={handleimg} src={data.img2} alt="" />
        </div>
      </div>


     {/* scond large pic */}
      <div className='Singlepro-main1child2'>
        <img src={imge} alt="" />
      </div>



       {/* title */}
      <div className='Singlepro-main1child3'>
       <div className="heading"><h3>{data.title}</h3>
       <a style={{fontSize:"13px",color:"blue"}} href="">FREECITY</a>
      
       </div>
       <div className="mb-1">
            <AiFillStar color="#cccccc" />
            <AiFillStar color="#cccccc" />
            <AiFillStar color="#cccccc" />
            <AiFillStar color="#cccccc" />
            <a style={{fontSize:"13px",marginLeft:"5px"}} href="">Write a review</a>
          </div>
          <p style={{marginBottom:"4px",fontSize:"18px"}}>${data.price}</p>
          <p style={{marginBottom:"-7px",fontSize:"13px",color:"#5c5c5f"}}>Or 4 interest-free installments of $58.75 with</p>
          <span>
            {" "}
            <img
              style={{ width: "10%" }}
              src="https://www.anthropologie.com/static/v3/images/klarna-logo-e1f1797f9730029d90fccb75c4be22cc.svg"
              alt=""
            />{" "}
          </span>
          <span>or</span>
          <span>
            {" "}
            <img
              style={{ width: "10%" }}
              src="https://www.anthropologie.com/static/v3/images/afterpay-logo-7904b549fb7a2a970c606efc9f1e8260.svg"
              alt=""
            />{" "}
          </span>
          <p className='online'>Online Exclusive</p>

          <hr />

          <p className='color' >Color: <span> DARK BLUE</span></p>
          <p className='family' style={{fontSize:"14px",marginBottom:"2px"}}>Size*</p>


          <div
            className="btn-group mb-3"
            role="group"
            aria-label="Basic radio toggle button group"
          >
            <input
              // onChange={handleChange}
              value="S"
              type="radio"
              className="btn-check"
              name="size"
              id="btnradio1"
              autoComplete="off"
            />
            <label className="btn btn-outline-primary" htmlFor="btnradio1">
              S
            </label>

            <input
              // onChange={handleChange}
              value="M"
              type="radio"
              className="btn-check"
              name="size"
              id="btnradio2"
              autoComplete="off"
            />
            <label className="btn btn-outline-primary" htmlFor="btnradio2">
              M
            </label>

            <input
              // onChange={handleChange}
              value="L"
              type="radio"
              className="btn-check"
              name="size"
              id="btnradio3"
              autoComplete="off"
            />
            <label className="btn btn-outline-primary" htmlFor="btnradio3">
              L
            </label>
          </div>
          <button onClick={handleSubmit} className='button'>ADD TO BASKET</button>



          <div style={{width:"85%"}} className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  Product Details
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  <p style={{fontSize:"13px",color:"#5c5c5f"}}>Style No. 66667379; Color Code: 042</p>
                  <ul style={{fontSize:"13px",color:"#5c5c5f"}}>
                    <li>Cotton</li>
                    <li>Machine Wash</li>
                    <li>USA</li>
                  </ul>
                  <p style={{color:"#5c5c5f"}}>DIMENSIONS</p>
                  <ul style={{fontSize:"13px",color:"#5c5c5f"}}>
                    <li>12" rise</li>
                    <li>24" inseam</li>
                    <li>5" leg opening</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Shipping & Returns
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  <h6>Shipping</h6>
                  <p style={{fontSize:"13px",color:"#5c5c5f"}}>
                    At checkout, we’ll provide you with an estimated delivery
                    date for your order based on your shipping method. Standard
                    shipping charges may apply based on the order value.
                    AnthroPerks members enjoy free Standard Shipping on all
                    orders $50+. Learn more about our shipping{" "}
                  </p>
                  <h6>Returns</h6>
                  <p style={{fontSize:"13px",color:"#5c5c5f"}}>
                    Merchandise must not be worn, washed, or altered. All tags
                    must be attached and items must be returned in original
                    packaging. Most merchandise can be returned within 60 days
                    of the purchase date. A refund will be issued to the
                    original form of payment at the original selling price. If
                    returned after 60 days, a merchandise credit will be issued
                    for the the original selling price.
                  </p>
                  <p style={{fontSize:"13px",color:"#5c5c5f"}}>For fast and free returns, find your local store.</p>
                  <p style={{fontSize:"13px",color:"#5c5c5f"}}>
                    Prefer to return by mail? View our complete return policy
                    and/or start your return online here.
                  </p>
                  <p style={{fontSize:"13px",color:"#5c5c5f"}}>
                    Just to note: shoes, bedding, curtains, and swimwear must be
                    shipped back to our warehouse and cannot be returned to a
                    store. Good news – online returns for these items are free!
                  </p>
                </div>
              </div>
            </div>
          </div>
      </div>



      {/* last pic   */}
      <div className='Singlepro-main1child4'>
        <div className='Singlepro-main1child4child'>
        <img src="https://images.ctfassets.net/5de70he6op10/49ZN2bC1GSrPz57veyGnGu/60a4a4ff587ad34d08ff2b744baf2976/Casual_Text.jpg?w=630&q=80&fm=webp" alt="" />
        </div>
        <div className='Singlepro-main1child4child'>
        <img src="https://images.ctfassets.net/5de70he6op10/1DlsysSG4ETmC3G7DvKsZP/3317c0b53d59a8c33aac87d7e5ca7bf2/Party_Text.jpg?w=630&q=80&fm=webp" alt="" />
        </div>
        <div className='Singlepro-main1child4child'>
        <img src="https://images.ctfassets.net/5de70he6op10/5H08nws8ZSjUGkae6rDamQ/fc2ee28cd74d54788e9bca6b03bea20f/White_Text.jpg?w=630&q=80&fm=webp" alt="" />
        </div>
        <div className='Singlepro-main1child4child'>
        <img src="https://images.ctfassets.net/5de70he6op10/7sBhabDqL1c2zVvyXNFIf/b5fd57c71d3c45abe6582231b3d4d8c8/Wedding_Text.jpg?w=630&q=80&fm=webp" alt="" />
        </div>
        <div className='Singlepro-main1child4child'>
        <img src="https://images.ctfassets.net/5de70he6op10/6aGiwPaIMLxjOfGxHhedpB/8410af29c1e4442f800dfb024dc6252b/Formal_Text.jpg?w=630&q=80&fm=webp" alt="" />
        </div>

      </div>

     </div>
      
    </div>
  )
}

export default SingleProduct
